import React from 'react';

const IconGallery = () => (
  <svg
    // width="800px"
    // height="800px"
    role="img"
    viewBox="0 0 32 32"
    stroke="currentColor"
    strokeWidth="2"
    className="feather">
    <g id="Page-1" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icon-Set" transform="translate(-360.000000, -99.000000)" fill="currentColor">
        <path
          d="M368,109 C366.896,109 366,108.104 366,107 C366,105.896 366.896,105 368,105 C369.104,105 370,105.896 370,107 C370,108.104 369.104,109 368,109 L368,109 Z M368,103 C365.791,103 364,104.791 364,107 C364,109.209 365.791,111 368,111 C370.209,111 372,109.209 372,107 C372,104.791 370.209,103 368,103 L368,103 Z M390,116.128 L384,110 L374.059,120.111 L370,116 L362,123.337 L362,103 C362,101.896 362.896,101 364,101 L388,101 C389.104,101 390,101.896 390,103 L390,116.128 L390,116.128 Z M390,127 C390,128.104 389.104,129 388,129 L382.832,129 L375.464,121.535 L384,112.999 L390,118.999 L390,127 L390,127 Z M364,129 C362.896,129 362,128.104 362,127 L362,126.061 L369.945,118.945 L380.001,129 L364,129 L364,129 Z M388,99 L364,99 C361.791,99 360,100.791 360,103 L360,127 C360,129.209 361.791,131 364,131 L388,131 C390.209,131 392,129.209 392,127 L392,103 C392,100.791 390.209,99 388,99 L388,99 Z"
          id="image-picture"></path>
      </g>
    </g>
  </svg>
);

export default IconGallery;
